(function () {
  angular
    .module("akitabox.ui.dialogs.workOrder.reopen")
    .factory("ReopenWorkOrderDialog", ReopenWorkOrderDialog);

  /* @ngInject */
  function ReopenWorkOrderDialog($log, $q, $mdDialog, $mdMedia) {
    var modal = {
      templateUrl:
        "app/core/ui/dialogs/work-order/reopen/reopen-work-order.dialog.html",
      controller: "ReopenWorkOrderDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: false,
    };

    // Enable fullscreen mode while on mobile
    if ($mdMedia("sm") || $mdMedia("xs")) {
      modal.fullscreen = true;
    }

    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, `options.locals.workOrderIDs` and `options.locals.building` are required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object|Error}               Promise that resolves with the reopened workOrders
     */
    function show(options) {
      // Verify we have workOrderIDs and building locals
      if (
        !options ||
        !options.locals ||
        !options.locals.workOrders ||
        !options.locals.workOrders.length > 0
      ) {
        $log.error(
          "ReopenWorkOrderDialog: you must pass in workOrderIDs and building via locals"
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
